module.exports = {
  reset: require('../css/reset.css'),
  onboarding: require('../components/onboarding/onboarding.scss'),
  simplesChip: require('../css/components/simples-chip.css'),
  simplesButtonJs: require('./components/simples-button'),
  topNavbarJs: require('../components/navbar/navbar.js')
};
